import React from 'react';
import { storyblokEditable } from 'gatsby-source-storyblok';
import { NewLabel } from '../../atoms/labels';
import { LinkWrapper } from '../../../utils/link';
import useHideOnSite from '../../../hooks/useLanguageFilter';
import { getSiteConfig } from '../../../../siteConfig';
import { translateStoryName } from '../../../utils/story';
import MobileSubLinkItem from './mobileMenuLinkItemSub';

const MobileMenuLinkItem = ({ item, trackingParent }) => {
  const currentLanguage = getSiteConfig().storyblokLanguage;

  return useHideOnSite(item.hide_on_site) ? null : (
    <div key={item._uid}>
      <LinkItemWrapper
        item={item}
        className={`font-md no-underline leading-10 py-2 font-medium `}
        trackingId={`${trackingParent}-${item.text}`}
      >
        {item.use_custom_name_for_link
          ? item.text || 'Text not found'
          : translateStoryName(item.link.story, currentLanguage)}
        &nbsp;
        {item.link_style === 'new' && <NewLabel />}
      </LinkItemWrapper>
      <div>
        {item.sub_links.map((sub) => (
          <MobileSubLinkItem
            item={sub}
            key={sub._uid}
            trackingParent={`${trackingParent}-${item.text}`}
          />
        ))}
      </div>
    </div>
  );
};

const LinkItemWrapper = ({ item, children, trackingId }) => {
  if (item.link.cached_url && item.link.id) {
    return (
      <LinkWrapper
        link={item.link}
        className={`font-md no-underline leading-10 py-2 font-medium`}
        key={item._uid}
        {...storyblokEditable(item)}
        trackingId={trackingId}
      >
        {children}
      </LinkWrapper>
    );
  } else {
    return (
      <div
        className={`font-md no-underline leading-10 py-0 font-medium `}
        key={item._uid}
        {...storyblokEditable(item)}
      >
        {children}
      </div>
    );
  }
};

export default MobileMenuLinkItem;
